
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"44","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 6h28v6H0V6zm0 8h28v6H0v-6zm0 8h28v6H0v-6zM31 14l6 6 6-6z"}})])
          )
        }
      }
    